module.exports = __webpack_public_path__ + "img/3d-space-64.ebadf370.svg";